import { ChangeDetectionStrategy, Component } from '@angular/core';
import { Select } from '@ngxs/store';
import { RegionOverlayService } from '@x/ecommerce-shop/app/core/region/services/region-overlay.service';
import {
  IRegionStateModel,
  RegionState,
} from '@x/ecommerce-shop/app/core/region/state/region.state';
import { Observable } from 'rxjs';

@Component({
  selector: 'x-region-add-to-cart-detail',
  templateUrl: './region-add-to-cart-detail.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { class: 'x-region-add-to-cart-detail' },
})
export class RegionAddToCartDetailComponent {
  @Select(RegionState) regionState$: Observable<IRegionStateModel>;

  constructor(public regionService: RegionOverlayService) {}
}
